<template>	
	<div class="main__container">
	    <div class="main__content">
			<h1 class="page-title">{{ data.category.name }}</h1>
			<div class="page-summary">
				<p>{{ data.category.desc }}</p>
			</div>
			<ul v-if="data.category.sub_categories2.length" class="directory--bookmarks">								
				<li v-for="(sub, index) in data.category.sub_categories2">
					<a :href="'#' + sub.slug">{{ sub.name }}</a>
				</li>
			</ul>
	        <section :id="sub.slug" v-for="(sub, index) in data.category.sub_categories2">
	        	<h2 class="page-subtitle">
	        		<a :href="sub.link">{{ sub.name }}</a>
	        	</h2>
	        	<div class="page-subdesc" style="margin-bottom: 20px;">{{ sub.desc }}</div>
	            <ul class="results" v-if="sub.topics.length" v-for="(top, index) in sub.topics">
                    <li class="result">
                        <div class="result__snippet">
                            <div class="result__title">
                            	<a :href="top.link">{{ top.name }}</a>
                            </div>
                            <div class="result__description">{{ top.desc }}</div>
                            <ul class="directory--bookmarks" style="margin-top: 20px;" v-if="top.sub_topics.length">								
                            	<li v-for="(sub_top, index) in top.sub_topics">
                            		<a :href="sub_top.link">{{ sub_top.name }}</a>
                            	</li>
                            </ul>
                        </div>
                    </li>     
	            </ul>
	        </section>
	    </div>
	    <div class="main__sidebar-first" id="reference">
	        <nav class="directory directory--sidebar" style="padding-right: 20px;">
	            <ul class="menu menu--directory">
	            	<li v-for="(cat, index) in data.categories" :class="checkActiveCategory(cat.slug)"><a :href="cat.link">{{ cat.name }}</a></li>
	            </ul>
	        </nav>
	    </div>
	</div>
</template>

<script>
	export default {
        props: ['data'],    
        methods: {
        	checkActiveCategory(res) {
        		if (this.data.category.slug == res) {
        			return 'menu__item is-active';
        		}
        		else {
        			return 'menu__item';
        		}
        	},
        },       
	}
</script>